import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import cn from 'classnames';
/**/
import { useAuth0 } from '../../../context/auth0';
import { CheckoutCard } from '../../common/CheckoutCard';
import { Input } from '../../Input';
import InputPhone from '../../InputPhone';

const _BILLING_FIRST_NAME = 'billing_first_name';
const _BILLING_LAST_NAME = 'billing_last_name';
const _BILLING_EMAIL = 'billing_email';
const _BILLING_PHONE = 'billing_phone';

export const EntryData = (props) => {
  const auth = useAuth0();
  const { register, /*handleSubmit, */ errors, setValue } = useForm({
    reValidateMode: 'onChange',
  });
  useEffect(() => {
    const values = [];
    if (auth && auth.user && auth.user.first_name) {
      values.push({
        [_BILLING_FIRST_NAME]: auth.user.first_name,
      });
    }
    if (auth && auth.user && auth.user.last_name) {
      values.push({
        [_BILLING_LAST_NAME]: auth.user.last_name,
      });
    }
    if (auth && auth.user && auth.user.email) {
      values.push({
        [_BILLING_EMAIL]: auth.user.email,
      });
    }
    if (auth && auth.user && auth.user.phone && props.prefixesAreVisible === '0') {
      values.push({ [_BILLING_PHONE]: auth.user.phone });
    }
    values.length && setValue(values);
  }, [auth.user]);
  return (
    <CheckoutCard
      className={cn('dedication')}
      title={app_main_wpml.insert_data}
      showTitleOnMbl={true}
    >
      <Input
        className={cn('dedication__input')}
        errored={!!errors[_BILLING_FIRST_NAME]}
        shadowed
        label={`${app_main_wpml.first_name}*`}
        name={_BILLING_FIRST_NAME}
        setRef={register({ required: true, max: 1000 })}
        dataGtmItem="checkout-form"
        dataGtmDetail="billing_first_name"
      />
      <Input
        className={cn('dedication__input')}
        errored={!!errors[_BILLING_LAST_NAME]}
        shadowed
        label={`${app_main_wpml.last_name}*`}
        name={_BILLING_LAST_NAME}
        setRef={register({ required: true, max: 1000 })}
        dataGtmItem="checkout-form"
        dataGtmDetail="billing_last_name"
      />
      <Input
        className={cn('dedication__input')}
        errored={!!errors[_BILLING_EMAIL]}
        label={app_main_wpml.Email + "*"}
        shadowed
        name={_BILLING_EMAIL}
        setRef={register({
          required: true,
          max: 1000,
          pattern: /^\S+@\S+$/i,
        })}
        dataGtmItem="checkout-form"
        dataGtmDetail="billing_email"
        readOnly
      />

      {props.prefixesAreVisible === '1' ? (
        <InputPhone
          className={cn('dedication__input')}
          errored={!!errors[_BILLING_PHONE]}
          label={`${app_main_wpml.phone}*`}
          shadowed
          name={_BILLING_PHONE}
          value={
            auth.user && auth.user.phone
              ? auth.user.phone : null
          }
          dataGtmItem="profile-form"
          dataGtmDetail="phone"
          setRef={register({
            required: false
          })}
        />
      ) : (
        <Input
          className={cn('dedication__input')}
          errored={!!errors[_BILLING_PHONE]}
          label={`${app_main_wpml.phone}*`}
          shadowed
          name={_BILLING_PHONE}
          setRef={register({
            required: true,
            max: 1000,
            pattern: /^\d+$/,
          })}
          dataGtmItem="checkout-form"
          dataGtmDetail="billing_phone"
        />
      )}

      <input type="hidden" id="password" name="password" value="c9H13NO3" />
    </CheckoutCard>
  );
};
